"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewInitRequest = void 0;
var NewInitRequest = /** @class */ (function () {
    function NewInitRequest() {
    }
    return NewInitRequest;
}());
exports.NewInitRequest = NewInitRequest;
;
//# sourceMappingURL=newInit.request.js.map